import React from 'react';
import { useTranslation } from 'react-i18next';
import RoomRosterIcon from 'assets/svgs/roomRoster.svg';
import { Link } from 'react-router-dom';
import './RoomRosterDashboard.scss';

const RoomRosterDashboard = (props) => {
  const { t } = useTranslation();
  return (
    <div className="mt-24 room-roster-section">
      <h5>{t('roomDashboard.roomRoster.title')}</h5>
      <div className="border-box-silver">
        <p>{t('roomDashboard.roomRoster.infoText')}</p>
        <Link
          href={`/test-event/${props.eventId}/room/${props.roomId}/roster`}
          to={`/test-event/${props.eventId}/room/${props.roomId}/roster`}
          className="btn btn-small btn-action m-0">
          <RoomRosterIcon />
          <span>{t('roomDashboard.roomRoster.title')}</span>
        </Link>
      </div>
    </div>
  );
};

export default RoomRosterDashboard;
